"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseStatus = exports.httpStatus = exports.APIError = void 0;
const responseStatus = exports.responseStatus = {
  SUCCESS: "success"
};
const httpStatus = exports.httpStatus = {
  SUCCESS: 200
};
class APIError extends Error {
  constructor(message) {
    super(message);
    this.name = "APIError";
  }
}
exports.APIError = APIError;